import { useEffect } from 'react';
import {
  createGlassStyle,
  createWaterDropStyle,
  waterDropKeyframes,
} from '../styles/glass-effects';

export const useGlassStyles = (currentColor: string) => {
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.innerText = waterDropKeyframes;
    document.head.appendChild(styleSheet);
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  return {
    glassStyle: createGlassStyle(currentColor),
    waterDropStyle: createWaterDropStyle(),
  };
};
